module.exports = __webpack_public_path__ + "assets/img/5.e0d1dc0e.png";